import { Box } from '@mui/material';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';

interface TablePillProps {
  label: string;
}

const TablePill = ({ label }: TablePillProps) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box
        sx={{
          p: '4px 12px',
          background: '#FFF',
          borderRadius: '20px',
          fontSize: '10px',
          lineHeight: '24px',
          fontWeight: 700,
          color: '#162C36',
          border: '0.5px solid #E8EAEB',
          textTransform: 'uppercase',
          boxShadow: '0px 0.75px 1.93px 0px #E8EAEB59',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '4px',
        }}
      >
        {label}
        <ArrowForwardOutlinedIcon sx={{ fontSize: '14px' }} />
      </Box>
    </Box>
  );
};

export default TablePill;
